exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3bbunACrfLWpm4{padding:0 12px}._3bbunACrfLWpm4 p{margin:0 0 16px}", ""]);

// exports
exports.locals = {
	"confirmContainer": "_3bbunACrfLWpm4"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"modules":true,"importLoaders":2,"localIdentName":"[hash:base64:14]","sourceMap":false}!./node_modules/postcss-loader/lib?{"config":{"path":"/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-2936/tools/webpack/postcss.config.js"},"sourceMap":true}!./node_modules/less-loader/dist/cjs.js?{"outputStyle":"expanded","sourceMap":false}!./app/gamma/src/components/popover/popover-confirm.less
// module id = SR5h
// module chunks = 13